import styled, {keyframes} from "styled-components"
import { AiOutlineCloseCircle } from "react-icons/ai"
import { useAdmin } from "../../../context/admin"
import { FormEvent, useEffect, useState } from "react"
import AdminService from "../../../services/admin.service"
import * as CommonTypes from '../../../types/common.types'
import { format, add } from "date-fns"
import removeTimezone from "../../../utils/removeTimezone"
import { useGlobal } from "../../../context/global"
import InputDropdown from "../../common/InputDropdown"
import Checkbox from "../../common/Checkbox"
import GeneralInput from "../../common/GeneralInput"

export default function AssignRservation() {
    const { setMessage, setIsLoading } = useGlobal()
    const {assignTripReservationId, setAssignTripReservationId, assignTripTourId, setAssignTripTourId, currentDay, setCurrentDay} = useAdmin()
    const [list, setList] = useState<CommonTypes.Trip[]>([])
    const [tripSelected, setTripSelected] = useState<string>()
    const [isCreatingNewTrip, setIsCreatingNewTrip] = useState<boolean>(false)
    const [guiders, setGuiders] = useState<CommonTypes.Guider[]>([])
    const [drivers, setDrivers] = useState<CommonTypes.Driver[]>([])
    const [cars, setCars] = useState<CommonTypes.Car[]>([])
    const [newTrip, setNewTrip] = useState<Partial<CommonTypes.TripReservation>>({})
    useEffect(() => {
        async function getList() {
            setIsLoading(true)
            try {
                if (!currentDay || !assignTripTourId) return 
                const response = await (await AdminService.listTripsByDay(currentDay, assignTripTourId)).data
                setList(response)
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
        getList()
        async function getInfo() {
            setIsLoading(true)
            try {
                const guidersResponse = (await AdminService.listGuiders()).data
                setGuiders(guidersResponse)
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
            try {
                const driversResponse = (await AdminService.listDrivers()).data
                setDrivers(driversResponse)
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
            try {
                const carsResponse = (await AdminService.listCars()).data
                setCars(carsResponse)
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
        getInfo()
    }, [currentDay, assignTripTourId])
    async function assign() {
        setIsLoading(true)
        try {
            if (!tripSelected) return
            const response = await AdminService.assignTrip(assignTripReservationId, tripSelected)
            setMessage({type: 'success', content: response.data})
            setTimeout(() => {
                setMessage(undefined)
            }, 2500)
            await setCurrentDay((prevDay: Date) => add(prevDay, {days: 1}))
            await setCurrentDay((prevDay: Date) => add(prevDay, {days: -1}))
            setAssignTripReservationId([])
            setAssignTripTourId(undefined)
        } catch (error: any) {
            console.log(error)
            if (typeof error?.response?.data === 'string') {
                setMessage({type: 'error', content: error.response.data})
                setTimeout(() => setMessage(undefined), 6000)
            }
        } finally {
            setIsLoading(false)
        }
    }

    async function submitTrip(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            // El trip nuevo es del día que se está viendo (el de las reservas): un trip de otra fecha
            // quedaba con pasajeros de otro día.
            const trip = (await AdminService.createTrip({tour_id: assignTripTourId, ...newTrip, trip_date: currentDay})).data
            const response = await AdminService.assignTrip(assignTripReservationId, trip.id)
            setMessage({type: 'success', content: response.data})
            setTimeout(() => {
                setMessage(undefined)
            }, 2500)
            await setCurrentDay((prevDay: Date) => add(prevDay, {days: 1}))
            await setCurrentDay((prevDay: Date) => add(prevDay, {days: -1}))
            setAssignTripReservationId([])
            setAssignTripTourId(undefined)
            setIsCreatingNewTrip(false)
            setNewTrip({})
        } catch (error: any) {
            console.log(error)
            if (typeof error?.response?.data === 'string') {
                setMessage({type: 'error', content: error.response.data})
                setTimeout(() => setMessage(undefined), 6000)
            }
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <Main>
            <Modal>
                {
                    list.map((trip, idx) => {
                        return (
                        <div className={`trip ${tripSelected === trip.id ? 'selected' : ''}`} key={idx}
                        onClick={() => setTripSelected(trip.id)}
                        >
                            <div className="header">
                                <span>
                                    {trip.trip_date && removeTimezone(trip.trip_date.toString())}
                                </span>
                                <span>
                                    {trip.trip_time}
                                </span>
                                    
                            </div>
                        <TableWrapper>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Guider</th>
                                        <th>Driver</th>
                                        <th>Pickup</th>
                                        <th>Car Patent</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{trip.guider?.name}</td>
                                        <td>{trip.driver?.name}</td>
                                        <td>{trip.pickup?.toString()}</td>
                                        <td>{trip.car?.license_plate}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </TableWrapper>
                        </div>
                        )
                    })
                }
                <button type="submit"
                onClick={assign}
                >Assign</button>
                <button
                type="submit"
                onClick={() => setIsCreatingNewTrip(true)}
                >
                    Create new trip and assign
                </button>
                {
                    isCreatingNewTrip &&
                    <NewTrip onSubmit={submitTrip}>
                        <InputDropdown
                        style={{marginBottom: '20px'}}
                        options={guiders}
                        label="Guider ID"
                        optionDefaultHeight={53}
                        onChange={(newValue: string) => setNewTrip(prevData => ({...prevData, guider_id: newValue}))}
                        keys={['id', 'name']}
                        selector="id"
                        />
                        <InputDropdown
                        style={{marginBottom: '20px'}}
                        options={drivers}
                        label="Driver ID"
                        keys={['id', 'name']}
                        selector="id"
                        optionDefaultHeight={53}
                        onChange={(newValue: string) => setNewTrip(prevData => ({...prevData, driver_id: newValue}))}
                        />
                        <InputDropdown
                        style={{marginBottom: '20px'}}
                        options={cars}
                        label="Car ID"
                        keys={['id', 'brand', 'model', 'license_plate']}
                        selector="id"
                        optionDefaultHeight={93}
                        onChange={(newValue: string) => setNewTrip(prevData => ({...prevData, car_id: newValue}))}
                        />
                        <Checkbox
                        checked={newTrip?.pickup || false}
                        color="#33AADD"
                        label="Pickup"
                        containerStyle={{marginBottom: '20px'}}
                        onChange={(newValue: boolean) => setNewTrip(prevData => ({...prevData, pickup: newValue}))}
                        />
                        {
                            !newTrip?.pickup &&
                            <GeneralInput
                            value={newTrip.meeting_point || ''}
                            label="Meeting point"
                            style={{marginBottom: '20px'}}
                            onChange={e => setNewTrip(prevData => ({...prevData, meeting_point: e.target.value}))}
                            />
                        }
                        <div className="calendar">
                            <span>Fecha: {currentDay && format(currentDay, 'd MMM yyyy')} (la de las reservas)</span>
                        </div>
                        <input type="time"
                        required
                        onChange={(e) => setNewTrip(prevData => ({...prevData, trip_time: e.target.value}))}
                        />
                        <GeneralInput
                        type="text"
                        value={newTrip.recommendations}
                        onChange={e => setNewTrip(prevData => ({...prevData, recommendations: e.target.value}))}
                        label="Recommendations"
                        style={{marginBottom: '20px'}}
                        />
                        <div className="actions">
                            <div className="cancel"
                            onClick={() => {
                                setIsCreatingNewTrip(false)
                            }}
                            >
                                Cancel
                            </div>
                            <button className="submit" type="submit">
                                Create
                            </button>
                        </div>
                    </NewTrip>
                }
                <div className="close" title="close"
                    onClick={() => {
                        setAssignTripReservationId([])
                        setAssignTripTourId(undefined)
                    }}
                >
                    <AiOutlineCloseCircle/>
                </div>
            </Modal>
        </Main>
    )
}

const Main = styled.div`
z-index: 100;
position: fixed;
top: 0;
left: 0;
width: 100vw;
height: 100vh;
background-color: ${props => props.theme.blackTransparent};
`

const showUpModal = keyframes`
    from {
        top: 100%;
    }
    to {
        top: 50%;
    }
    `

const Modal = styled.div`
width: 80%;
max-height: 75%;
min-height: 400px;
overflow: hidden;
overflow-y: unset;
max-width: 500px;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
background-color: ${props => props.theme.white};
box-shadow: 0 0 20px ${props => props.theme.blackTransparent};
padding: 20px;
padding-top: 50px;
animation: ${showUpModal} .3s ease forwards;
.trip {
    background-color: ${props => props.theme.whiteBackground};
    border-radius: 10px;
    box-shadow: 0 3px 5px ${props => props.theme.blackTransparent};
    cursor: pointer;
    margin-bottom: 20px;
    .header {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px 10px 0 0;
        position: relative;
        height: 40px;
        gap: 10px;
        background-color: ${props => props.theme.black};
        color: ${props => props.theme.white};
        
    }
}
.trip.selected {
    border: 1px solid ${props => props.theme.lightGreen};
    box-shadow: 0 3px 10px ${props => props.theme.lightGreenFade};
}
.close {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 22px;
    cursor: pointer;
}
button[type=submit] {
    display: inline-block;
    padding: 0 10px;
    height: 2.6em;
    line-height: 2.5em;
    overflow: hidden;
    font-size: 17px;
    z-index: 1;
    background-color: ${props => props.theme.white};
    color: ${props => props.theme.blue};
    border: 2px solid ${props => props.theme.blue};
    border-radius: 6px;
    position: relative;
    cursor: pointer;
}

button[type=submit]::before {
    position: absolute;
    content: "";
    background: ${props => props.theme.blue};
    width: calc(100% + 100px);
    height: 200px;
    z-index: -1;
    border-radius: 50%;
}

button[type=submit]:hover {
    color: ${props => props.theme.white};
}

button[type=submit]:before {
    top: 100%;
    left: 100%;
    transition: .3s all;
}

button[type=submit]:hover::before {
    top: -30px;
    left: -30%;
}
`

const TableWrapper = styled.div`
width: 100%;
height: 100%;
`

const Table = styled.table`
position: relative;
table-layout: fixed;
height: 100%;
width: 100%;
thead {
    width: 100%;
    background-color: #FFFFFF;
}
th {
    font-weight: 400;
    > button {
        width: 20px;
        height: 20px;
        color: #FFF;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        line-height: 40px;
        background-color: ${props => props.theme.white};
        border: 1px solid ${props => props.theme.black};
        border-radius: 5px;
        cursor: pointer;
        transition: transform .3s ease;
        &:active {
            transform: scale(0.8);
            }
    }
    >button.selected-all {
        background-color: ${props => props.theme.yellowDark};
    }
}
td {
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    .flag {
        width: 30px;
    }
    button.select {
        width: 20px;
        height: 20px;
        color: #FFF;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        line-height: 40px;
        background-color: ${props => props.theme.white};
        border: 1px solid ${props => props.theme.black};
        border-radius: 5px;
        cursor: pointer;
        transition: transform .3s ease;
        &:active {
            transform: scale(0.8);
        }
    }
    button.selected {
        background-color: ${props => props.theme.yellowDark};
    }
}
tr {
    height: 40px;
    width: 100%;
}
`

const NewTrip = styled.form`
width: 95%;
margin: 20px auto;
padding: 15px;
background-color: ${props => props.theme.blackTransparent};
input[type='time'] {
    padding: 5px 10px;
    margin: 20px 0;
    cursor: pointer;
}
.calendar {
    display: flex;
    align-items: center;
    gap: 10px;
}
.actions {
    display: flex;
    gap: 15px;
    button, .cancel {
        display: inline-block;
        width: 6.5em;
        height: 2.6em;
        overflow: hidden;
        font-size: 17px;
        text-align: center;
        z-index: 1;
        border-radius: 6px;
        position: relative;
        cursor: pointer;
    }
    .cancel {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid ${props => props.theme.black};
    }
    .submit {
        background-color: ${props => props.theme.white};
        color: ${props => props.theme.blue};
        border: 2px solid ${props => props.theme.blue};

    }
    .submit::before {
        position: absolute;
        content: "";
        background: ${props => props.theme.blue};
        width: 170px;
        height: 200px;
        z-index: -1;
        border-radius: 50%;
    }
    
    .submit:hover {
        color: ${props => props.theme.white};
    }
    
    button:before, .cancel:before {
        top: 100%;
        left: 100%;
        transition: .3s all;
    }
    
    button:hover::before, .cancel:hover::before {
        top: -30px;
        left: -30px;
    }
}
`